var map = {
	"./carousel_item_azts.png": 45519,
	"./carousel_item_cwjz.png": 67099,
	"./carousel_item_gclqd.png": 1300,
	"./carousel_item_gcsj.png": 62012,
	"./carousel_item_gjfw.png": 28791,
	"./carousel_item_jjbzx.png": 58665,
	"./carousel_item_jjfa.png": 86314,
	"./carousel_item_jsbzx.png": 47466,
	"./carousel_item_pjbl.png": 88325,
	"./carousel_item_rkjba.png": 60923,
	"./carousel_item_sbyw.png": 16402,
	"./carousel_item_spzz.png": 60096,
	"./carousel_item_swbzx.png": 1907,
	"./carousel_item_tbsb.png": 62352,
	"./carousel_item_twsj.png": 46653,
	"./carousel_item_xcbm.png": 93105,
	"./carousel_item_xckc.png": 24332,
	"./carousel_item_xmgl.png": 57677,
	"./carousel_item_xqgt.png": 19297,
	"./carousel_item_xsbf.png": 68898,
	"./carousel_item_zjscc.png": 31140,
	"./carousel_item_zlbx.png": 28529
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 75740;